import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private toast: ToastController) {}

  /**
   * @param duration ms; long errors (e.g. referee conflicts) pass a larger value.
   *        Toasts over the default also get a Dismiss button.
   */
  public async showToast(header, message, color?, duration = 4000) {
    const toast = await this.toast.create({
      header,
      message,
      position: 'bottom',
      duration,
      color,
      buttons: duration > 4000 ? [{ text: 'Dismiss', role: 'cancel' }] : undefined,
    });
    await toast.present();
  }
}
